module.exports = __webpack_public_path__ + "img/uber-eatsLogo.225cff09.svg";